import { Stack, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Image from '@@components/Image';
import { RouterButton } from '@@components/RouterLink';
import unityLogoBig from '@@images/unity-logo-big.png';

const WrapperStack = styled(Stack)({
    width: '100%',
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
});

const Title = styled('h1')(({ theme }) => ({
    ...theme.typography.subtitle1,
    marginBottom: theme.spacing(2),
}));

const Subtitle = styled('h2')(({ theme }) => ({
    ...theme.typography.large,
    margin: `0 0 ${theme.spacing(3)} 0`,
}));

const Logo = styled(Image)({
    width: '400px',
});

export const Error404 = () => {
    const { t } = useTranslation();

    return (
        <WrapperStack>
            <Logo src={unityLogoBig} alt="Unity Home" />
            <Title>{t('404.title')}</Title>
            <Subtitle>{t('404.subtitle')}</Subtitle>
            <RouterButton to="/" color="secondary" variant="contained">
                {t('404.button')}
            </RouterButton>
        </WrapperStack>
    );
};
